// Import common components
import { FlexBox } from '../../common/Box'
import Description from '../../common/Description'
import Button from '../../common/Button'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'
import TYPOGRAPHY from '../../../themes/Typography'

export const Wrapper = FlexBox.extend`
  height: auto;
  background-color: ${COLORS.bgContact};
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 768px) {
    height: ${px2Rem(270)};
  }
`

export const ContactDesc = Description.extend`
  font-family: ${TYPOGRAPHY.TYPE.base};
  font-size: ${px2Rem(26)};
  margin-bottom: ${px2Rem(27)};
  text-align: center;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`

export const StartedBtn = Button.extend`
  width: 100%;
  height: ${px2Rem(60)};
  border: none;
  font-family: ${TYPOGRAPHY.TYPE.base};
  font-size: ${TYPOGRAPHY.SIZE.xxTiny};

  @media (min-width: 768px) {
    width: ${px2Rem(280)};
    height: ${px2Rem(70)};
    font-size: ${TYPOGRAPHY.SIZE.tiny};
    font-family: ${TYPOGRAPHY.TYPE.light};
    border: solid ${px2Rem(2)};
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/contact/ContactResponsive.js